<template lang="pug">
div
  | There is no content available to display.
</template>
<script>
  export default {
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/Inventions/NoContent.vue